import { useEffect } from "react";

/**
 * iOS-safe body scroll lock via position:fixed.
 * Refcounted so nested sheets share one lock without unlocking early.
 */

type LockSnapshot = {
  scrollX: number;
  scrollY: number;
  position: string;
  top: string;
  left: string;
  right: string;
  overflow: string;
  width: string;
};

let lockCount = 0;
let snapshot: LockSnapshot | null = null;

function lockBody(): void {
  const { body } = document;
  snapshot = {
    scrollX: window.scrollX,
    scrollY: window.scrollY,
    position: body.style.position,
    top: body.style.top,
    left: body.style.left,
    right: body.style.right,
    overflow: body.style.overflow,
    width: body.style.width,
  };

  body.style.position = "fixed";
  body.style.top = `-${snapshot.scrollY}px`;
  body.style.left = `-${snapshot.scrollX}px`;
  body.style.right = "0";
  body.style.overflow = "hidden";
  body.style.width = "100%";
}

function unlockBody(): void {
  if (!snapshot) {
    return;
  }
  const { body } = document;
  const prev = snapshot;
  snapshot = null;
  body.style.position = prev.position;
  body.style.top = prev.top;
  body.style.left = prev.left;
  body.style.right = prev.right;
  body.style.overflow = prev.overflow;
  body.style.width = prev.width;
  window.scrollTo(prev.scrollX, prev.scrollY);
}

export function useScrollLock(locked: boolean): void {
  useEffect(() => {
    if (!locked) {
      return;
    }

    if (lockCount === 0) {
      lockBody();
    }
    lockCount += 1;

    return () => {
      lockCount = Math.max(0, lockCount - 1);
      if (lockCount === 0) {
        unlockBody();
      }
    };
  }, [locked]);
}
